import React from 'react';
import { connect } from 'react-redux';
import { usuarioSelector } from '../../selectors/sessionSelector';
import PagosYDevoluciones  from '../../components/PagosYDevoluciones';

const PagosYDevolucionesContainer = ({ usuario }) => {
  return (
    <div style={{ minHeight: '100vh' }}>
      <PagosYDevoluciones usuario={usuario} />
    </div>
  );
};

const mapStateToProps = state => ({
  usuario: usuarioSelector(state),
});

export default connect(mapStateToProps)(PagosYDevolucionesContainer);